var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"titulo"},[_c('h1',[_vm._v("Total es: $"+_vm._s(Number(_vm.total.toFixed(2)))+" MXN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }